import api from '../config/axiosConfig';
import { Item, ItemFormValues, ItemWithStock } from '../types/item';
import { API_BASE_URL } from '../utils/constants';

const API_URL = `${API_BASE_URL}/items`;

export const getItems = async (params?: {
  category?: string;
  search?: string;
  has_warranty?: boolean;
  include_inactive?: boolean;
  page?: number;
  page_size?: number;
}): Promise<Item[]> => {
  const response = await api.get<Item[]>(API_URL, { params });
  return response.data;
};

export const getCategories = async (): Promise<string[]> => {
  const response = await api.get<string[]>(`${API_URL}/categories`);
  return response.data;
};

export const getItemById = async (id: number): Promise<Item> => {
  const response = await api.get<Item>(`${API_URL}/${id}`);
  return response.data;
};

export const getItemBySku = async (sku: string): Promise<Item> => {
  const response = await api.get<Item>(`${API_URL}/sku/${sku}`);
  return response.data;
};

export const getItemByBarcode = async (barcode: string): Promise<Item> => {
  const response = await api.get<Item>(`${API_URL}/barcode/${barcode}`);
  return response.data;
};

export const createItem = async (item: ItemFormValues): Promise<Item> => {
  const response = await api.post<Item>(API_URL, item);
  return response.data;
};

export const updateItem = async (id: number, item: Partial<ItemFormValues>): Promise<Item> => {
  // Backend menggunakan PATCH bukan PUT
  const response = await api.patch<Item>(`${API_URL}/${id}`, item);
  return response.data;
};

export const deleteItem = async (id: number): Promise<void> => {
  // Soft delete - set is_active = false
  await api.delete(`${API_URL}/${id}`);
};

export const uploadItemImage = async (id: number, file: File): Promise<Item> => {
  const formData = new FormData();
  formData.append('file', file);
  const response = await api.post<Item>(`${API_URL}/${id}/image`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
  return response.data;
};

export const getItemImage = async (id: number): Promise<Blob> => {
  const response = await api.get(`${API_URL}/${id}/image`, {
    responseType: 'blob',
  });
  return response.data;
};

export const deleteItemImage = async (id: number): Promise<void> => {
  await api.delete(`${API_URL}/${id}/image`);
};
